import styled from 'styled-components';

export const FormSectionGapVertical = styled.div`
	margin-top: var(--form-section-gap-vertical);
`